var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-table',{ref:"table",attrs:{"url":"/api/v1/transaction","filter":_vm.filter,"attributes":[
    {
      attribute: 'id',
      name: 'ID'
    },
    {
      attribute: 'customer_profile',
      name: 'Mitglied',
      type: 'LinkProfileCell',
      sortable: false
    },
    {
      type: 'DateTimeCell',
      attribute: 'created_at',
      name: 'Erstellt'
    },
    {
      type: 'DateTimeCell',
      attribute: 'paid_at',
      name: 'Bezahlt'
    },
    {
      attribute: 'amount',
      name: 'Einheiten'
    },
    {
      type: 'CurrencyCell',
      attribute: 'price',
      name: 'Preis'
    },
    {
      attribute: 'service_string',
      name: 'Methode',
      type: 'ServiceStringCell',
      sortable: false
    },
    {
      type: 'ManualTransactionCell',
      attribute: 'was_created_by_admin',
      name: 'Manuell?'
    },
    {
      type: 'TransactionConfirmCell',
      attribute: 'state',
      name: 'Gebucht?'
    }
  ]}},[_c('div',{attrs:{"slot":"filter"},slot:"filter"},[_c('table-filter',{attrs:{"filterComponents":[
        {
          type: 'DropdownFilter',
          label: 'Zahlungsart- / Dienstleister',
          options: _vm.serviceOptions,
          attributes: 'service'
        },
        {
          type: 'DateFilter',
          label: 'Datum von',
          attributes: { column: 'updated_at', operator: '>=' }
        },
        {
          type: 'DateFilter',
          label: 'Datum bis',
          attributes: { column: 'updated_at', operator: '<=' }
        },
        {
          type: 'WhereFilter',
          label: 'ID',
          attributes: 'id'
        },
        {
          type: 'WhereFilter',
          label: 'Profile-ID',
          attributes: 'customer_profile_id'
        },
        {
          type: 'WhereLikeFilter',
          label: 'Kunde',
          attributes: 'customerProfile.name'
        }
      ]},on:{"apply-filters":function($event){return _vm.$bus.$emit('refresh-table', _vm.$refs.table.id)}},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }